import * as React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Col, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { CPItemEditComponent, EditState } from './CPItemEditComponent';
import { CPItemWarning } from './CPItemWarning';

export interface TextAreaEditInputProps {
    name: string;
    textDefaultValue: string;
    textTitleValue?: string;
    cancelHandler: () => void;
    className?: string;
    editHandler: () => void;
    editItemKey: string | undefined;
    editName: string;
    error?: boolean;
    errorMessage?: string;
    saveHandler: (a: string) => void;
}

export interface TextAreaEditInputState {
    textValue: string;
    validationError?: boolean;
}

export default class TextAreaEditInput extends React.PureComponent<TextAreaEditInputProps, TextAreaEditInputState> {
    constructor(props: TextAreaEditInputProps) {
        super(props);
        this.state = {
            textValue: '',
            validationError: false,
        };
    }

    public componentWillReceiveProps() {
        this.setState({
            textValue: this.props.textDefaultValue,
        });
    }

    public render() {
        const { textValue } = this.state;
        return (
            <CPItemEditComponent
                name={this.props.name}
                editHandler={this.props.editHandler}
                saveHandler={() => {
                    if (textValue.length < 3) {
                        this.setState({ validationError: true });
                    } else {
                        this.setState({ validationError: false }, () => {
                            this.props.saveHandler(textValue);
                        });
                    }
                }}
                cancelHandler={this.props.cancelHandler}
                content={this.renderContent()}
                contentEdit={this.renderContentEdit()}
                editState={this.editStateThisComponent()}
                error={this.props.error}
                errorMessage={this.props.errorMessage}
                validationError={this.state.validationError}
                validationMessage={this.state.validationError ? TR.textAreaEditInput_check_data : ''}
            />
        );
    }

    private editStateThisComponent() {
        let myEditState: EditState;
        if (this.props.editItemKey === this.props.editName) {
            myEditState = EditState.This;
        } else if (this.props.editItemKey === undefined) {
            myEditState = EditState.None;
        } else {
            myEditState = EditState.Other;
        }
        return myEditState;
    }

    private renderContent = () => {
        if (!this.props.textDefaultValue) {
            return (
                <Col className="mt-2">
                    <CPItemWarning errorMessage={TR.textAreaEditInput_missing_data} />
                </Col>
            );
        } else {
            return (
                <Col md={12}>
                    {this.props.textDefaultValue && <div className="mb-1 mt-1">{this.props.textDefaultValue}</div>}
                </Col>
            );
        }
    };

    private renderContentEdit = () => {
        return (
            <Row style={{ width: '100%' }}>
                <Col md={12}>
                    <TextareaAutosize
                        style={{
                            border: this.state.textValue.length < 3 ? '1px solid red' : 'inherit',
                            maxHeight: 800,
                            minHeight: 100,
                            width: '100%',
                        }}
                        autoFocus={true}
                        id={this.props.editName}
                        name={this.props.editName}
                        defaultValue={this.props.textDefaultValue}
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                            this.setState({ textValue: e.currentTarget.value });
                        }}
                    />
                    {this.props.textTitleValue && (
                        <span style={{ fontSize: '14px', color: '#666' }}>{this.props.textTitleValue}</span>
                    )}
                </Col>
            </Row>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/TextAreaEditInput.tsx